module.exports = __webpack_public_path__ + "static/img/sample-pic3.6ce8a8de.png";